import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpVentures'

export const stageList = (params = '') => Http.get(`/admin/venture-stages${serialize(params)}`)
export const stageCreate = (params = '') => Http.post('/admin/venture-stages', params)
export const stageByID = (params = '') => Http.get(`/admin/venture-stages/${params}`)
export const stageUpdate = (params = '') => Http.put(`/admin/venture-stages/${params.id}`, params)
export const stageDestroy = (params = '') => Http.delete(`/admin/venture-stages/${params.id}`)
